import BQuantity from "./BQuantity";

export default class BEnergy
{
	CAL_TO_J_RATIO = 4.128;

	constructor(amount, unit)
	{
		this.amount = amount;
		this.unit = unit;
	}

	getJoules()
	{
		switch (this.unit.toUpperCase()) {
			case "J":
				return this.amount;
				break;
			case "KJ":
				return this.amount * 1000;
				break;
			case "CAL":
				return this.amount * this.CAL_TO_J_RATIO;
				break;
			case "KCAL":
				return this.amount * this.CAL_TO_J_RATIO * 1000;
				break;
		}
	}

	getQuantity(unit)
	{
		switch (unit.toUpperCase()) {
			case "J":
				return new BQuantity(this.getJoules(), "J");
				break;
			case "KJ":
				return new BQuantity(this.getJoules() * .001, "kJ");
				break;
			case "CAL":
				return new BQuantity(this.getJoules() * (1 / this.CAL_TO_J_RATIO), "cal");
				break;
			case "KCAL":
				return new BQuantity(this.getJoules() * (1 / this.CAL_TO_J_RATIO) * .001, "kcal");
				break;
		}
	}
}
